/* PassionSim — avis Judge.me : copie la note moyenne (1 décimale, virgule en FR)
   dans data-ps-avg, que passionsim-custom.css affiche en gros chiffre.
   Judge.me redessine son widget après le chargement : on surveille le DOM. */
(function () {
  var queued = false;
  function run() {
    queued = false;
    document.querySelectorAll('.jdgm-rev-widg').forEach(function (w) {
      var el = w.querySelector('.jdgm-rev-widg__summary-average');
      var a = parseFloat(w.getAttribute('data-average-rating'));
      if (!el || isNaN(a) || a === 0) return;
      var s = a.toFixed(1);
      if (document.documentElement.lang.indexOf('fr') === 0) s = s.replace('.', ',');
      if (el.getAttribute('data-ps-avg') !== s) el.setAttribute('data-ps-avg', s);
    });
  }
  function schedule() { if (!queued) { queued = true; setTimeout(run, 50); } }
  document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
